





























































































import { fetchSolicitudBaja } from '../fetchSolicitudBaja';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';
import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';

@Component({
  components: {
    DatePicker,
  },
})
export default class Formulario extends ComponenteBaseStepper {
  @Prop({ required: true }) clientes: any;

  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  formulario: boolean = false;
  mounted() {}

  rules = {
    required: (value: any) => !!value || 'Required.',
    negativo: (value: any) => value >= 0 || 'Required.',
  };

  cerrarModal() {
    this.$emit('modalAsociacionEmit', false);
  }

  crearCliente() {
    let clienteSelected = this.clientes.find(
      (e: any) => e.id == this.formFields.cliente.value
    );
    let cliente = {
      crmBaja: this.formFields.crmBaja.value,
      crmFecha: this.formFields.crmFecha.value,
      rut: this.formFields.rut.value,
      clienteNombre: clienteSelected.nombre,
      clienteId: clienteSelected.id,
      equipos: this.formFields.equipos.value,
      perifericos: this.formFields.perifericos.value,
      autor: this.formFields.autor.value,
      concepto: this.formFields.concepto.value,
    };

    if (cliente.perifericos == 0 && cliente.equipos == 0) {
      this.$snotify.error(
        'Por favor, ingrese al menos un equipo o un periférico',
        {
          timeout: 3000,
        }
      );
    } else {
      this.$emit('modalAsociacionEmit', false);
      this.$emit('clienteCreado', cliente);
    }
  }

  formFields: {
    crmBaja: any;
    crmFecha: any;
    rut: any;
    cliente: any;
    equipos: any;
    perifericos: any;
    autor: any;
    concepto: any;
  } = {
    crmBaja: {
      label: 'CRM Baja',
      value: '',
    },
    crmFecha: {
      label: 'CRM Fecha',
      value: moment(),
    },
    rut: {
      label: 'RUT',
      value: '',
    },
    cliente: {
      label: 'Cliente',
      value: '',
    },
    equipos: {
      label: 'Equipos',
      value: 0,
    },
    perifericos: {
      label: 'Periféricos',
      value: 0,
    },
    autor: {
      label: 'Autor',
      value: '',
    },
    concepto: {
      label: 'Concepto',
      value: '',
    },
  };

  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dictionaryFormErrors: any = {};
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //Interface
  editedItem: IFuncionalidad = {};

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
